import React from 'react';
import { useDispatch } from 'react-redux';
import { fnLogout } from 'utils/logout';

import { Link } from 'react-router-dom';
import { TiHome } from 'react-icons/ti';
import { FiLogOut } from 'react-icons/fi';
import { HeaderButtonsContainer } from './HeaderButtons.css.js';

const HeaderButtons = ( props ) => {
  const dispatch = useDispatch();

  return (
    <HeaderButtonsContainer className="headerButtons">
      <ul className="buttonBox">
        <li>
          <Link to="/" className="buttonName"><TiHome />HOME</Link>
        </li>
        <li className="logout-button" onClick={() => { fnLogout(dispatch, props.history); }}>
          <div className="buttonName"><FiLogOut />LOG OUT</div>
        </li>
      </ul>
    </HeaderButtonsContainer>
  )
}

export default HeaderButtons;